"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.POIJSONRPCMethod = exports.POI_REQUIRED_LISTS = exports.POIListType = exports.POI_SHIELD_PENDING_SEC_TEST_NET_TEXT = exports.POI_SHIELD_PENDING_SEC_TEST_NET = exports.POI_SHIELD_PENDING_SEC_TEXT = exports.POI_SHIELD_PENDING_SEC = exports.POIStatus = exports.BlindedCommitmentType = exports.POIEventType = void 0;
var POIEventType;
(function (POIEventType) {
    POIEventType["Shield"] = "Shield";
    POIEventType["Transact"] = "Transact";
    POIEventType["Unshield"] = "Unshield";
    POIEventType["LegacyTransact"] = "LegacyTransact";
})(POIEventType || (exports.POIEventType = POIEventType = {}));
var BlindedCommitmentType;
(function (BlindedCommitmentType) {
    BlindedCommitmentType["Shield"] = "Shield";
    BlindedCommitmentType["Transact"] = "Transact";
    BlindedCommitmentType["Unshield"] = "Unshield";
})(BlindedCommitmentType || (exports.BlindedCommitmentType = BlindedCommitmentType = {}));
var POIStatus;
(function (POIStatus) {
    // POI valdated in event list
    POIStatus["Valid"] = "Valid";
    // Shield blocked
    POIStatus["ShieldBlocked"] = "ShieldBlocked";
    // Transact/Unshield proof submitted, but not validated yet
    POIStatus["ProofSubmitted"] = "ProofSubmitted";
    // Missing internal/external transact/unshield proof, or ShieldPending
    POIStatus["Missing"] = "Missing";
})(POIStatus || (exports.POIStatus = POIStatus = {}));
exports.POI_SHIELD_PENDING_SEC = 60 * 60; // 1 hour
exports.POI_SHIELD_PENDING_SEC_TEXT = 'One hour';
exports.POI_SHIELD_PENDING_SEC_TEST_NET = 1 * 60; // 1 minute
exports.POI_SHIELD_PENDING_SEC_TEST_NET_TEXT = 'One minute';
var POIListType;
(function (POIListType) {
    POIListType["Active"] = "Active";
    POIListType["Gather"] = "Gather";
})(POIListType || (exports.POIListType = POIListType = {}));
exports.POI_REQUIRED_LISTS = [
    {
        key: 'efc6ddb59c098a13fb2b618fdae94c1c3a807abc8fb1837c93620c9143ee9e88',
        type: POIListType.Active,
        name: 'Chainalysis OFAC Sanctions API',
        description: 'API which is used to restrict bad actors designated by the US Department of the Treasury. See: https://www.chainalysis.com/free-cryptocurrency-sanctions-screening-tools.',
    },
];
var POIJSONRPCMethod;
(function (POIJSONRPCMethod) {
    POIJSONRPCMethod["NodeStatus"] = "ppoi_node_status";
    POIJSONRPCMethod["POIEvents"] = "ppoi_poi_events";
    POIJSONRPCMethod["POIMerkletreeLeaves"] = "ppoi_poi_merkletree_leaves";
    POIJSONRPCMethod["TransactProofs"] = "ppoi_transact_proofs";
    POIJSONRPCMethod["LegacyTransactProofs"] = "ppoi_legacy_transact_proofs";
    POIJSONRPCMethod["BlockedShields"] = "ppoi_blocked_shields";
    POIJSONRPCMethod["SubmitPOIEvents"] = "ppoi_submit_poi_events";
    POIJSONRPCMethod["SubmitValidatedTXID"] = "ppoi_submit_validated_txid";
    POIJSONRPCMethod["RemoveTransactProof"] = "ppoi_remove_transact_proof";
    POIJSONRPCMethod["SubmitTransactProof"] = "ppoi_submit_transact_proof";
    POIJSONRPCMethod["SubmitLegacyTransactProofs"] = "ppoi_submit_legacy_transact_proofs";
    POIJSONRPCMethod["SubmitSingleCommitmentProofs"] = "ppoi_submit_single_commitment_proofs";
    POIJSONRPCMethod["POIsPerList"] = "ppoi_pois_per_list";
    POIJSONRPCMethod["POIsPerBlindedCommitment"] = "ppoi_pois_per_blinded_commitment";
    POIJSONRPCMethod["MerkleProofs"] = "ppoi_merkle_proofs";
    POIJSONRPCMethod["ValidatedTXID"] = "ppoi_validated_txid";
    POIJSONRPCMethod["ValidateTXIDMerkleroot"] = "ppoi_validate_txid_merkleroot";
    POIJSONRPCMethod["ValidatePOIMerkleroots"] = "ppoi_validate_poi_merkleroots";
})(POIJSONRPCMethod || (exports.POIJSONRPCMethod = POIJSONRPCMethod = {}));
